<script setup>
import { ref } from 'vue';
import service1Img from '../../../../assets/images/service1.png';
import service2Img from '../../../../assets/images/service2.png';
import service3Img from '../../../../assets/images/service3.png';
import service4Img from '../../../../assets/images/service4.png';
import service5Img from '../../../../assets/images/service5.png';
import service6Img from '../../../../assets/images/service6.png';

const services = ref([
  {
    id: 1,
    title: '睇命盤/睇八字',
    description:
      '睇命盤、睇八字，唔係迷信，而係了解自己、掌握未來嘅第一步。命理如鏡，幫你睇清性格同運勢，用正面心態迎接人生每個高低起伏。',
    image: service1Img,
    buttonText: '睇命盤',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 2,
    title: '法事祈福',
    description:
      '通過正宗道教科儀，向神明啟稟祈福，化太歲、還受生債、補財庫三步同修，由內到外調和命格。助你化煞解厄、轉運增福、補足財氣，無論祈求財運、姻緣、健康或事業，都能聚氣納福，讓運勢持續上升。',
    image: service2Img,
    buttonText: '睇姻緣',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 3,
    title: 'BB起名',
    description: '為BB起個有獨特含義、寓意美好的名',
    image: service3Img,
    buttonText: '起名服務',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 4,
    title: '家居風水/辦公室風水',
    description: ' 辦公室／陽宅平面圖風水睇法，幫你搵出最旺財、旺人丁嘅風水寶位',
    image: service4Img,
    buttonText: '睇風水',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 5,
    title: '擇吉日',
    description: '婚嫁、新屋入伙、商鋪開張、剖腹產等等重要日子為你精準揀個吉日吉時！',
    image: service5Img,
    buttonText: '擇吉日',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 6,
    title: '課程講座',
    description:
      '對風水命理、玄學術數有興趣？機會嚟啦！大師親授陰陽宅風水、手面相、八字、卜卦等等，帶你走入風水殿堂，學習真正嘅中國智慧。',
    image: service6Img,
    buttonText: '學習課程',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
]);
</script>

<template>
  <section class="service-list-section">
    <h2 class="section-title">服務列表</h2>
    <p class="section-subtitle">八字玄機，命運之謎，幫你睇通人生機遇同挑戰！</p>
    <div class="services-container">
      <div
        v-for="service in services"
        :key="service.id"
        class="service-card"
      >
        <div class="service-image-container">
          <img
            :src="service.image"
            :alt="service.title"
            class="service-image"
          />
        </div>
        <div class="service-content">
          <h3 class="service-title">{{ service.title }}</h3>
          <p class="service-description">{{ service.description }}</p>
          <a
            :href="service.link"
            target="_blank"
            rel="noopener noreferrer"
            class="service-button"
          >
            {{ service.buttonText }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.service-list-section {
  width: 100%;
  padding: 20px 40px 10px;
  background: #ffffff;
}

.section-title {
  font-size: 15px;
  color: #4c360a;
  text-align: center;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 13px;
  color: #4c360a;
  text-align: center;
  margin-bottom: 50px;
  line-height: 1.6;
}

.services-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.service-card {
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  padding: 20px 10px;
}

.service-image-container {
  width: 100%;
  height: 150px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .service-image {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    display: block;
    object-fit: contain;
  }
}

.service-content {
  padding: 24px 0 0;
  flex: 1;
  display: flex;
  flex-direction: column;

  .service-title {
    font-size: 10px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 5px;
    line-height: 1.4;
    text-align: center;
  }

  .service-description {
    font-size: 8px;
    color: #666666;
    line-height: 1.8;
    margin-bottom: 20px;
    flex: 1;
    text-align: center;
  }

  .service-button {
    display: inline-block;
    padding: 6px 20px;
    background: #e5ae40;
    color: #000000;
    font-size: 8px;
    text-decoration: none;
    border-radius: 30px;
    text-align: center;
    align-self: center;
    cursor: pointer;
  }
}
</style>
